import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

const SFSvgIcon = (props) => {
  const {size, ...other} = props;
  return (
    <SvgIcon
      {...(props.component && { component: props.component })}
      fontSize={size}
      color={props.color}
      {...other}
    >
      {props.children}
    </SvgIcon>
  );
};

export default SFSvgIcon;
